import { SiteStagesQueryData, SiteStagesQueryVariables } from "react-migration/domains/sites/typings/SiteStage";

import { routedClient as client } from "react-migration/lib/persistence/apollo";
import { keyBy } from "lodash";
import siteStages from "react-migration/domains/sites/apollo/li-api/queries/siteStagesList.gql";
import { siteStore } from "src/js/stores/site/store";
import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { useSnapshot } from "valtio/react";

export const useSiteStages = () => {
  const { selectedWorkspaceId } = useSnapshot(siteStore);
  const { data, ...rest } = useQuery<SiteStagesQueryData, SiteStagesQueryVariables>(siteStages, {
    client,
    fetchPolicy: "cache-and-network",
    variables: {
      ...(selectedWorkspaceId ? { workspaceId: selectedWorkspaceId } : {}),
    },
    skip: !selectedWorkspaceId,
  });

  const stages = useMemo(() => data?.siteStagesPaginated.nodes ?? [], [data]);

  return { stages, ...rest };
};

export const useSiteStagesById = () => {
  const { stages } = useSiteStages();
  return useMemo(() => (stages ? keyBy(stages, "_id") : {}), [stages]);
};

interface SiteStageOption {
  id: string;
  name: string;
  color: string;
}

export function useSiteStagesOptions(): SiteStageOption[] {
  const { stages } = useSiteStages();
  return useMemo(
    () =>
      stages?.map((stage) => ({
        id: stage._id,
        name: stage.name,
        color: stage.color,
      })) ?? [],
    [stages]
  );
}
